import {Component, ChangeDetectionStrategy} from '@angular/core';

import {ScoreboardComponent} from '../scoreboard.component';

@Component({
    selector: 'scoreboard',
    changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: '../scoreboard.component.html'
})
export class AmericanFootballScoreboardComponent extends ScoreboardComponent {
	constructor() {
		super();
	}

}
